import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Power Drill",
        price: 35,
        disprice: 28,
        stock: 10,
        content: "Upgrade your toolbox with our high-performance Power Drill—designed for precision, power, and durability. Perfect for drilling through wood, metal, and plastic, this lightweight yet robust tool ensures smooth operation for professional and DIY projects.",
        description: "Our Power Drill is designed for precision and ease of use, making it an essential tool for both professionals and DIY enthusiasts. Built with a durable high-torque mechanism, it provides effortless drilling through wood, metal, and plastic. The ergonomic grip ensures comfort during extended use, while its compact design allows easy maneuverability in tight spaces. Whether for construction, repairs, or crafts, this drill delivers reliability and efficiency.",
        category: ["Power Tools", "Hand Tools"],
        tags: ["drilling", "handtool", "power"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Grade Steel & ABS Plastic" },
            { id: 2, title: "Weight", content: "1.2 lbs" },
            { id: 3, title: "Chuck Size", content: "3/8 inch" },
            { id: 4, title: "Speed", content: "Variable up to 1500 RPM" },
            { id: 5, title: "Grip", content: "Ergonomic Anti-Slip Handle" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "David Miller",
                date: "Feb 25, 2024",
                rating: 4.5,
                content: "Excellent hand drill! Lightweight yet powerful. I use it for woodwork and home repairs, and it performs flawlessly."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Sarah Johnson",
                date: "Feb 26, 2024",
                rating: 5,
                content: "This hand drill is a game-changer! Super easy to handle and works great on different materials. Highly recommend."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Screw",
        price: 35,
        disprice: 28,
        stock: 5,
        content: "Upgrade your toolbox with our high-performance Screw—designed for precision, power, and durability. Perfect for drilling through wood, metal, and plastic, this lightweight yet robust tool ensures smooth operation for professional and DIY projects.",
        description: "Our Screw is designed for precision and ease of use, making it an essential tool for both professionals and DIY enthusiasts. Built with a durable high-torque mechanism, it provides effortless drilling through wood, metal, and plastic. The ergonomic grip ensures comfort during extended use, while its compact design allows easy maneuverability in tight spaces. Whether for construction, repairs, or crafts, this tool delivers reliability and efficiency.",
        category: ["Fastening Equipment", "Hand Tools"],
        tags: ["fastening", "handtool", "toolkit"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Grade Steel & ABS Plastic" },
            { id: 2, title: "Weight", content: "1.2 lbs" },
            { id: 3, title: "Chuck Size", content: "3/8 inch" },
            { id: 4, title: "Speed", content: "Variable up to 1500 RPM" },
            { id: 5, title: "Grip", content: "Ergonomic Anti-Slip Handle" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "David Miller",
                date: "Feb 25, 2024",
                rating: 4.5,
                content: "Excellent hand drill! Lightweight yet powerful. I use it for woodwork and home repairs, and it performs flawlessly."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Sarah Johnson",
                date: "Feb 26, 2024",
                rating: 5,
                content: "This hand drill is a game-changer! Super easy to handle and works great on different materials. Highly recommend."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Screw Driver",
        price: 18,
        disprice: 14,
        stock: 8,
        content: "Tackle any job with our versatile Screw Driver—engineered for precision and comfort. Ideal for assembling furniture, fixing appliances, or simple repairs, it's a must-have for every toolbox.",
        description: "Our Screw Driver is crafted with high-strength steel for long-lasting performance and rust resistance. The magnetic tip ensures a firm hold on screws, while the ergonomic handle offers a comfortable grip for extended use. Perfect for electronics, furniture, and general repairs, this tool delivers excellent torque and precision. Its compact design allows easy access to tight spots, making it an essential tool for both pros and DIYers.",
        category: ["Hand Tools", "Fastening Equipment"],
        tags: ["fastening", "handtool", "toolkit"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Chrome Vanadium Steel" },
            { id: 2, title: "Weight", content: "0.4 lbs" },
            { id: 3, title: "Tip Type", content: "Magnetic Flat & Phillips" },
            { id: 4, title: "Handle", content: "Non-slip Ergonomic Grip" },
            { id: 5, title: "Length", content: "6 inches" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Mark Evans",
                date: "Mar 2, 2024",
                rating: 4.8,
                content: "High quality and very comfortable to use. Works great for electronics and general repairs!"
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Rachel Adams",
                date: "Mar 5, 2024",
                rating: 5,
                content: "Great screw driver! The magnetic tips make everything so much easier. Very happy with the purchase."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Wrench",
        price: 22,
        disprice: 17,
        stock: 0,
        content: "Take on tough bolts and nuts with ease using our heavy-duty Wrench—built for strength, grip, and durability. Perfect for plumbing, automotive, or home repair jobs.",
        description: "This durable Wrench is forged from heat-treated carbon steel for exceptional toughness and corrosion resistance. Its adjustable jaw fits a variety of nut and bolt sizes, making it incredibly versatile. The non-slip handle ensures a secure grip, even in greasy conditions, while its smooth-turn adjustment dial provides precise control. Ideal for mechanics, plumbers, and DIY enthusiasts, this tool is designed to handle pressure and deliver torque with confidence.",
        category: ["Hand Tools", "Fastening Equipment"],
        tags: ["wrench", "fastening", "handtool"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Heat-Treated Carbon Steel" },
            { id: 2, title: "Weight", content: "1.1 lbs" },
            { id: 3, title: "Jaw Type", content: "Adjustable" },
            { id: 4, title: "Grip", content: "Textured Anti-Slip Handle" },
            { id: 5, title: "Size", content: "10 inches" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "David Lee",
                date: "Apr 3, 2024",
                rating: 4.7,
                content: "Very solid wrench! Great grip and doesn’t slip. Love the quality for the price."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Angela Carter",
                date: "Apr 6, 2024",
                rating: 5,
                content: "Exactly what I needed for my plumbing repairs. Smooth adjustment and easy to handle!"
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Measuring Tape",
        price: 12,
        disprice: 9,
        stock: 6,
        content: "Measure with precision and confidence using our durable Measuring Tape—perfect for construction, tailoring, or DIY tasks around the home.",
        description: "This reliable Measuring Tape features a flexible, high-contrast tape for easy reading and accurate measurements. With a sturdy lock mechanism and impact-resistant casing, it's designed to withstand daily use in demanding environments. The smooth retractable action and belt clip make it easy to carry and operate single-handedly. Whether you're working on a building site or crafting at home, this tape delivers consistent performance.",
        category: ["Measuring Tools", "Hand Tools"],
        tags: ["measuring", "handtool", "toolkit"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Length", content: "25 feet (7.5 meters)" },
            { id: 2, title: "Blade Material", content: "Steel" },
            { id: 3, title: "Case Material", content: "ABS Plastic" },
            { id: 4, title: "Lock Type", content: "Thumb Lock" },
            { id: 5, title: "Units", content: "Inches & Centimeters" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Liam Brooks",
                date: "Apr 9, 2024",
                rating: 4.8,
                content: "Tough and very accurate—my go-to tape for every project. Handy and dependable!"
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Sophia Mitchell",
                date: "Apr 10, 2024",
                rating: 5,
                content: "Love the smooth retraction and clear markings. Super easy to work with!"
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Safety Hat",
        price: 20,
        disprice: 15,
        stock: 8,
        content: "Stay protected with our durable Safety Hat—built to guard against impact and keep you safe on every job site.",
        description: "Our Safety Hat is engineered for maximum head protection, featuring a high-density polyethylene shell and comfortable inner suspension system. Lightweight yet rugged, it’s ideal for construction workers, electricians, and anyone needing reliable headgear. Ventilation holes help with airflow, and the adjustable strap ensures a secure fit for all-day comfort.",
        category: ["Safety Gear", "Protective Equipment"],
        tags: ["safety", "helmet", "toolkit"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Density Polyethylene (HDPE)" },
            { id: 2, title: "Size", content: "Adjustable (One Size Fits Most)" },
            { id: 3, title: "Color Options", content: "Yellow, White, Blue, Red" },
            { id: 4, title: "Standards", content: "ANSI/ISEA Z89.1-2014" },
            { id: 5, title: "Suspension", content: "4-Point with Ratchet Adjustment" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Ethan Wright",
                date: "Apr 11, 2024",
                rating: 4.9,
                content: "Fits great and feels solid. A must-have on the job site!"
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Ava Thompson",
                date: "Apr 12, 2024",
                rating: 4.7,
                content: "Comfortable to wear for long hours. Provides great protection."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Complete Toolkit",
        price: 120,
        disprice: 95,
        stock: 4,
        content: "All-in-one Complete Toolkit with essential hand tools, perfect for both DIY tasks and professional projects.",
        description: "This Complete Toolkit includes a wide range of high-quality hand tools such as screwdrivers, pliers, wrench, measuring tape, utility knife, and more—all packed in a sturdy, portable carrying case. Whether you're assembling furniture, fixing appliances, or working on construction tasks, this toolkit has everything you need in one place.",
        category: ["Hand Tools", "Fastening Equipment"],
        tags: ["toolkit", "handtool", "fastening"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Contents", content: "45-Piece Set including Screwdrivers, Pliers, Wrench, Hammer, Tape, Knife" },
            { id: 2, title: "Case", content: "Hard Plastic Carrying Case" },
            { id: 3, title: "Material", content: "Chrome Vanadium Steel Tools" },
            { id: 4, title: "Weight", content: "3.5 kg" },
            { id: 5, title: "Warranty", content: "1-Year Manufacturer Warranty" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Olivia Harris",
                date: "Apr 13, 2024",
                rating: 4.8,
                content: "Super handy toolkit! Has everything I need for home repairs."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Liam Parker",
                date: "Apr 13, 2024",
                rating: 4.9,
                content: "High quality tools and easy to carry around. Definitely worth it."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Claw Hammer",
        price: 25,
        disprice: 18,
        stock: 0,
        content: "Durable Claw Hammer with a comfortable grip, ideal for both home use and professional carpentry.",
        description: "The Claw Hammer features a forged steel head and a non-slip rubber handle for maximum control and durability. Perfect for driving nails, removing them, or general construction tasks. A reliable tool that belongs in every toolbox.",
        category: ["Hand Tools", "Fastening Equipment"],
        tags: ["handtool", "fastening", "cutting"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Head Material", content: "Forged Steel" },
            { id: 2, title: "Handle", content: "Non-slip Rubber Grip" },
            { id: 3, title: "Size", content: "16 oz (455 g)" },
            { id: 4, title: "Length", content: "13 inches" },
            { id: 5, title: "Warranty", content: "1-Year Warranty" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Mason Clark",
                date: "Apr 13, 2024",
                rating: 4.7,
                content: "Solid build and very comfortable grip. Gets the job done!"
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Sophia Bennett",
                date: "Apr 13, 2024",
                rating: 4.6,
                content: "Great hammer for the price. Feels balanced and sturdy."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Heavy-Duty Wire Cutters",
        price: 22,
        disprice: 16,
        stock: 9,
        content: "Precision Wire Cutters designed for clean cuts through cables, wires, and metal cords with ease.",
        description: "These Heavy-Duty Wire Cutters offer high leverage for powerful cutting performance. The sharp, hardened steel blades ensure smooth, clean cuts while the ergonomic handle reduces hand fatigue. Ideal for electrical, automotive, and DIY projects.",
        category: ["Hand Tools", "Safety Gear"],
        tags: ["cutting", "handtool", "safety"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Blade Material", content: "Hardened Carbon Steel" },
            { id: 2, title: "Handle", content: "Ergonomic Non-slip Grip" },
            { id: 3, title: "Cutting Capacity", content: "Up to 2.5mm wire" },
            { id: 4, title: "Overall Length", content: "8 inches" },
            { id: 5, title: "Ideal Use", content: "Electrical, DIY, Auto Repair" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Liam Reed",
                date: "Apr 13, 2024",
                rating: 4.8,
                content: "Very sharp and precise. Cut through thick wires like butter."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Emily Torres",
                date: "Apr 13, 2024",
                rating: 4.5,
                content: "Feels great in hand and works perfectly for all my home electrical tasks."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Cordless Power Drill",
        price: 120,
        disprice: 98,
        stock: 40,
        content: "Versatile Cordless Power Drill with variable speed and powerful torque for drilling and driving applications.",
        description: "This Cordless Power Drill is equipped with a high-performance motor, delivering strong torque and consistent power. It features a variable speed trigger, keyless chuck, LED work light, and a compact design for tight spaces. Perfect for wood, metal, and plastic surfaces.",
        category: ["Power Tools", "Fastening Equipment"],
        tags: ["power", "drilling", "fastening"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Power Source", content: "18V Lithium-ion Battery" },
            { id: 2, title: "Speed Settings", content: "0-550 / 0-2000 RPM" },
            { id: 3, title: "Chuck Type", content: "Keyless 1/2-inch" },
            { id: 4, title: "Torque", content: "530 in-lbs max" },
            { id: 5, title: "LED Light", content: "Built-in for visibility in dark areas" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Sophia Knight",
                date: "Apr 13, 2024",
                rating: 5.0,
                content: "Powerful and lightweight—ideal for all my home improvement projects!"
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Noah Hayes",
                date: "Apr 13, 2024",
                rating: 4.6,
                content: "Battery lasts a long time and the drill is super easy to use. Great purchase."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Heavy Duty Fastener Set",
        price: 25,
        disprice: 18,
        stock: 150,
        content: "Comprehensive Fastener Set, including screws, bolts, nuts, and washers for various applications.",
        description: "This Heavy Duty Fastener Set includes a wide range of screws, bolts, nuts, and washers, designed for construction, automotive, and general repair use. Crafted from high-quality steel for strength and durability, this set ensures reliability in any project.",
        category: ["Fastening Equipment", "Hand Tools"],
        tags: ["fastening", "toolkit", "handtool"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Strength Steel" },
            { id: 2, title: "Set Contents", content: "100 screws, 50 bolts, 50 nuts, 50 washers" },
            { id: 3, title: "Size", content: "Variety of sizes (M4 to M12)" },
            { id: 4, title: "Coating", content: "Rust-resistant zinc coating" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Oliver Scott",
                date: "Mar 20, 2024",
                rating: 4.8,
                content: "Great value set! Has all the sizes I need for DIY projects. Very durable."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Emma Lee",
                date: "Mar 22, 2024",
                rating: 5.0,
                content: "Perfect for all my home repairs! The fasteners are solid and the packaging is very organized."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Precision Driver Tool Set",
        price: 30,
        disprice: 25,
        stock: 0,
        content: "Versatile Driver Tool Set designed for precision work in tight spaces. Ideal for electronics, watchmaking, and delicate repairs.",
        description: "The Precision Driver Tool Set includes multiple screwdriver heads in various sizes, perfect for small and intricate projects. This set is ideal for electronics, precision engineering, and DIY enthusiasts looking for a reliable and versatile set of driver tools. Made from durable materials for long-lasting performance.",
        category: ["Hand Tools", "Fastening Equipment"],
        tags: ["fastening", "handtool", "toolkit"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Chrome Vanadium Steel" },
            { id: 2, title: "Set Contents", content: "6 screwdriver heads, 1 handle" },
            { id: 3, title: "Grip", content: "Ergonomic Anti-Slip Handle" },
            { id: 4, title: "Use", content: "Ideal for precision work in electronics, watches, and small appliances" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Michael Grant",
                date: "Apr 5, 2024",
                rating: 4.7,
                content: "Perfect for delicate tasks. The variety of heads makes it versatile for different projects."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Sophia Turner",
                date: "Apr 7, 2024",
                rating: 5.0,
                content: "Amazing quality! Very precise, and the ergonomic handle makes it easy to use for long periods."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Adjustable Spanner",
        price: 25,
        disprice: 20,
        stock: 75,
        content: "Durable Adjustable Spanner designed for a wide range of tasks, providing flexibility and ease of use for professionals and DIY enthusiasts.",
        description: "This Adjustable Spanner features a smooth, durable mechanism that easily adjusts to fit various sizes of nuts and bolts. Its robust construction ensures reliable performance, making it a must-have tool for any toolbox. Whether you're working on plumbing, construction, or automotive repairs, this spanner provides optimal grip and control.",
        category: ["Hand Tools", "Fastening Equipment"],
        tags: ["wrench", "handtool", "fastening"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Carbon Steel" },
            { id: 2, title: "Size Range", content: "6 to 10 inches" },
            { id: 3, title: "Adjustability", content: "Smooth and precise adjustment mechanism" },
            { id: 4, title: "Grip", content: "Ergonomic Anti-Slip Handle" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "James Lee",
                date: "Apr 10, 2024",
                rating: 4.5,
                content: "Great spanner! Adjusts easily and feels very sturdy. It's my go-to tool for various projects."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Olivia Smith",
                date: "Apr 12, 2024",
                rating: 5.0,
                content: "Love this spanner! It's compact, easy to use, and works on all sizes of nuts and bolts."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Tape Measure",
        price: 15,
        disprice: 12,
        stock: 100,
        content: "Reliable Tape Measure designed for accurate measurements, offering easy-to-read markings and a smooth retractable mechanism.",
        description: "This Tape Measure is crafted for precise measurements with clear and easy-to-read markings. Featuring a durable casing and a smooth retractable mechanism, it’s perfect for both professional contractors and DIY enthusiasts. Whether you're measuring for construction, home improvement, or crafting projects, this tool is built to provide reliable, long-lasting service.",
        category: ["Measuring Tools", "Hand Tools"],
        tags: ["measuring", "handtool", "toolkit"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "ABS Plastic Casing, Steel Tape" },
            { id: 2, title: "Length", content: "25 feet" },
            { id: 3, title: "Width", content: "1 inch" },
            { id: 4, title: "Lock Mechanism", content: "Manual Lock" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "John Adams",
                date: "Mar 15, 2024",
                rating: 4.0,
                content: "Great tape measure! Easy to use and very sturdy. The lock mechanism is a nice touch."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Emily Brown",
                date: "Mar 18, 2024",
                rating: 5.0,
                content: "Perfect for all my home improvement projects. The measurements are spot on, and the tape retracts smoothly."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Safety Helmet",
        price: 35,
        disprice: 28,
        stock: 50,
        content: "Protect your head with our durable Safety Helmet, designed to offer comfort and superior protection in hazardous environments.",
        description: "Our Safety Helmet is engineered for maximum protection in construction sites, industrial work, and other risky environments. With a lightweight design, breathable inner lining, and adjustable fit, this helmet ensures safety without sacrificing comfort. It's made from high-impact materials to provide superior protection, making it a must-have for professionals working in challenging conditions.",
        category: ["Safety Gear", "Protective Equipment"],
        tags: ["safety", "helmet", "toolkit"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Impact ABS Plastic" },
            { id: 2, title: "Weight", content: "1.2 lbs" },
            { id: 3, title: "Size", content: "Adjustable, Fits Most Head Sizes" },
            { id: 4, title: "Safety Standard", content: "ANSI Z89.1-2009" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Michael Green",
                date: "Mar 20, 2024",
                rating: 5.0,
                content: "Great helmet for construction work! Comfortable and secure fit with excellent protection."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Linda Clark",
                date: "Mar 22, 2024",
                rating: 4.5,
                content: "Very comfortable to wear all day. Provides great protection and is very adjustable."
            }
        ]
    }
];

export default products;